import React from "react";
import ProductPage from "./ProductPage";
import image from "../Images/product-heroes/workspace-hero.png";
import detailImage from "../Images/dashboards/hr-dashboard.png";

const product = {
  "id": "workspace",
  "title": "Workspace Management",
  "headline": "Connect your spaces.",
  "accent": "Bring your teams together.",
  "description": "Organize office and hybrid workspaces with connected bookings, attendance and utilization insights. Keep workspace operations aligned with your HR teams.",
  "checks": [
    "Desk and room booking",
    "Hybrid team support",
    "Workspace insights"
  ],
  "badge": "Connected spaces and teams",
  "imageAlt": "Illustration of a modern hybrid office with desk and meeting room bookings",
  "summary": [
    {
      "icon": "building",
      "title": "Organized workspaces",
      "text": "Coordinate desks, rooms and locations."
    },
    {
      "icon": "people",
      "title": "Flexible team access",
      "text": "Support office and hybrid work models."
    },
    {
      "icon": "chart",
      "title": "Utilization insights",
      "text": "Understand how your workspaces are used."
    }
  ],
  "featuresTitle": "Make every workspace work for your team",
  "featuresSubtitle": "Connect space planning, employee access and everyday operations.",
  "features": [
    {
      "title": "Desk & meeting room booking",
      "icon": "building",
      "text": "Coordinate workspace reservations around your team schedules.",
      "points": [
        "Desk and meeting room reservations",
        "Real-time booking visibility",
        "Hybrid work seat allocation"
      ]
    },
    {
      "title": "Access & attendance",
      "icon": "calendar",
      "text": "Connect employee presence with the locations where they work.",
      "points": [
        "Geolocation-based check-ins",
        "Biometric and RFID integration",
        "Connected attendance records"
      ]
    },
    {
      "title": "Utilization analytics",
      "icon": "chart",
      "text": "Understand workspace usage to make better planning decisions.",
      "points": [
        "Occupancy monitoring",
        "Workspace usage trends",
        "Office layout planning insights"
      ]
    },
    {
      "title": "HR & payroll integration",
      "icon": "wallet",
      "text": "Bring workspace operations into your wider HR workflow.",
      "points": [
        "Employee schedule synchronization",
        "Attendance system connection",
        "Workspace expense tracking"
      ]
    },
    {
      "title": "Roles & security",
      "icon": "shield",
      "text": "Manage access around the needs of your teams and locations.",
      "points": [
        "Role-based permissions",
        "Restricted area access",
        "Employee information protection"
      ]
    },
    {
      "title": "Hybrid workforce coordination",
      "icon": "layers",
      "text": "Keep office and remote teams organized in a shared system.",
      "points": [
        "Support for hybrid work models",
        "Multiple work locations",
        "Connected employee schedules"
      ]
    }
  ],
  "detailImageAlt": "BillPunch HR dashboard showing employee teams, attendance and approvals",
  "detailLabel": "Built for Flexible Teams",
  "detailTitle": "Your locations, connected to your people.",
  "detailText": "Coordinate working schedules and understand workspace activity alongside employee and attendance information. Keep teams organized as your business grows.",
  "detailPoints": [
    "Coordinate office and hybrid schedules",
    "Connect attendance with workspace activity",
    "Review utilization across locations"
  ],
  "video": "https://www.youtube.com/watch?v=TtJ7D2yxtAY",
  "workflowTitle": "Create a more organized working environment",
  "steps": [
    [
      "Set up your spaces",
      "Add locations, desks and meeting rooms."
    ],
    [
      "Define access and schedules",
      "Configure permissions and working arrangements."
    ],
    [
      "Coordinate bookings",
      "Help teams reserve the spaces they need."
    ],
    [
      "Review and improve",
      "Use occupancy insights to plan workspace changes."
    ]
  ],
  "cta": "Make space for a better way to work."
};
product.image = image;
product.detailImage = detailImage;

const Workspacemanagement = () => <ProductPage product={product} />;

export default Workspacemanagement;
